<div class="h-[calc(100vh-86px)]"><app-file-explorer [storages]="storages()" (usageChanged)="loadStorages()"></app-file-explorer></div>
